import { createContext as ReactCreateContext } from "react";
import { createContext } from "../util/create-context.js";
import { createDescendantContext } from "../util/hooks/descendants/useDescendant.js";
export const ToggleGroupContext = ReactCreateContext(null);
export const [ToggleGroupDescendantsProvider, useToggleGroupDescendantsContext, useToggleGroupDescendants, useToggleGroupDescendant,] = createDescendantContext();
/* State context */
export const [ToggleGroupProvider, useToggleGroupContext] = createContext({
    name: "ToggleGroupContext",
    hookName: "useToggleGroupContext",
    providerName: "ToggleGroupProvider",
    errorMessage: "<ToggleGroup.Item> needs to be wrapped within <ToggleGroup>",
});
//# sourceMappingURL=ToggleGroup.context.js.map